import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
} from "antd";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import ActionsLog from "../../../../../components/common/ActionsLog";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import FormAction from "../../../../../components/common/FormAction";
import Notes from "../../../../../components/common/Notes";
import PageHeading from "../../../../../components/common/PageHeading";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";
import RightBar from "../../../../../components/common/RightBar";
import TreeMultiSelect from "../../../../../components/common/TreeSelect";

import { chargesTableData, glAccounts, tenants } from "../../../../../data/accounting";

import { FaRegEdit } from "react-icons/fa";
import { TbCurrencyDollar } from "react-icons/tb";


function ChargeDetails() {
  const [checked, setChecked] = useState(false);
  const [chargeDetails, setChargeDetails] = useState({});

  const { id } = useParams();

  useEffect(() => {
    const newObject = chargesTableData.find((item) => {
      return item.id === Number(id);
    });
    setChargeDetails(newObject);
  }, []);

  const onCancel = () => {
    setChecked(false);
  };

  const [isReverseCharge, setIsReverseCharge] = useState(false);
  const showReverseCharge= () => {
    setIsReverseCharge(true);
  };
  const handleOk = () => {
    setIsReverseCharge(false)
  };
  const handleCancel = () => {
    setIsReverseCharge(false)
  };

  const ChargeDetailsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "Tenant Receipt",
        "1",
        "",
        "",
        "/accounting/receivables_payments/reciepts/tenant_receipts/new"
      ),
      RightBarMethod(
        "Homeowner Receipt",
        "2",
        "",
        "",
        "/accounting/receivables_payments/reciepts//HomeownerReceipt"
      ),
      RightBarMethod(
        "Other Receipt",
        "3",
        "",
        "",
        "/accounting/receivables_payments/reciepts/otherReceipt"
      ),
      RightBarMethod(
        "Subsidy Receipt",
        "4",
        "",
        "",
        "/accounting/receivables_payments/reciepts/subsidyreceipt"
      ),
      RightBarMethod(
        "Application Fee",
        "5",
        "",
        "",
        "/accounting/receivables_payments/reciepts/newapplicationfee"
      ),
      RightBarMethod(
        "Bulk Charges & Credits",
        "8",
        "",
        "",
        "/accounting/receivables_payments/invoices/bulkchargesandcredits"
      ),
      RightBarMethod(
        "Tenant Charge",
        "6",
        "",
        "",
        "/accounting/receivables_payments/invoices/tenantcharge"
      ),
      RightBarMethod(
        "Homeowner Charge",
        "7",
        "",
        "",
        "/accounting/receivables_payments/invoices/homeownercharge"
      ),
      RightBarMethod(
        "Bulk Recurring Charges",
        "9",
        "",
        "",
        "/accounting/receivables_payments/invoices/bulkrecurringcharges"
      ),
      RightBarMethod(
        "Tenant Credit",
        "10",
        "",
        "",
        "/accounting/receivables_payments/invoices/newtenantcredit"
      ),
      RightBarMethod(
        "Homeowner Credit",
        "11",
        "",
        "",
        "/accounting/receivables_payments/invoices/newhomeownercredit"
      ),
      RightBarMethod(
        "Apply Credits",
        "12",
        "",
        "",
        "/accounting/receivables_payments/reciepts/applycredits"
      ),
      RightBarMethod(
        "Common Charge",
        "13",
        "",
        "",
        "/accounting/receivables_payments/invoices/NewCommonCharge"
      ),
      RightBarMethod(
        "Charge Late Fees",
        "14",
        "",
        "",
        "/accounting/receivables_payments/chargelatefees"
      ),
      RightBarMethod(
        "New Bank Deposit",
        "15",
        "",
        "",
        "/accounting/receivables_payments/bank_deposits/NewBankDeposit"
      ),
      RightBarMethod(
        "Lockbox",
        "16",
        "",
        "",
        "/accounting/receivables_payments/lockbox"
      ),
      RightBarMethod(<span onClick={showReverseCharge}>Reverse Charge</span>, "17", "", "", ""),
    ]),
    RightBarMethod(
      " HELP TOPICS",
      "t2",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod("Tenant Payment Plan", "18", "", "", ""),
        RightBarMethod("Homeowner Payment Plan", "19", "", "", ""),
      ]
    ),
  ];
  

  return (
    <>
      <div className="receipt-details">
        {!checked ? (
          <Row gutter={[8, 0]} justify="end">
            <Col>
              <button
                className="icon-btn-container"
                onClick={() => setChecked(true)}
              >
                <FaRegEdit size={16} />
                <span>Edit</span>
              </button>
            </Col>
          </Row>
        ) : null}
        <PageHeading heading="Tenant Charge" />
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
        >
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <Card>
                {checked ? (
                  <>
                    <Form.Item label="Tenant">
                      <Select options={tenants} placeholder="Select..." showSearch allowClear />
                    </Form.Item>
                    <Form.Item label="Total Amount">
                    <InputNumber addonBefore={<TbCurrencyDollar size={16} /> } style={{ width: "100%" }}/>
                    </Form.Item>
                    <Form.Item label="Amount Paid">
                      <p>
                        {chargeDetails?.tenantCharge
                          ? `$ ${chargeDetails.tenantCharge.amountPaid}`
                          : null}{" "}
                        ( <span className="onclick-text">Generate Invoice</span>{" "}
                        )
                      </p>
                    </Form.Item>
                    <Form.Item label="Charge Date">
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="Posting Date">
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="GL Account">
                      <TreeMultiSelect options={glAccounts} placeholder="Select..."/>
                    </Form.Item>
                    <Form.Item label="Description">
                      <Input />
                    </Form.Item>
                    <Form.Item label="Payment Plan">
                      <Checkbox></Checkbox>
                    </Form.Item>
                  </>
                ) : (
                  <>
                    <Form.Item label="Tenant">
                      <p className="onclick-text">
                        {chargeDetails?.tenantCharge
                          ? chargeDetails.tenantCharge.tenant
                          : null}
                      </p>
                    </Form.Item>
                    <Form.Item label="Total Amount">
                      <p>
                        {chargeDetails?.tenantCharge
                          ? `$ ${chargeDetails.tenantCharge.totalAmount}`
                          : null}{" "}
                        ( <span className="onclick-text">Generate Invoice</span>{" "}
                        )
                      </p>
                    </Form.Item>
                    <Form.Item label="Amount Paid">
                      <p>
                        {chargeDetails?.tenantCharge
                          ? `$ ${chargeDetails.tenantCharge.amountPaid}`
                          : null}{" "}
                        ( <span className="onclick-text">Generate Invoice</span>{" "}
                        )
                      </p>
                    </Form.Item>
                    <Form.Item label="Charge Date">
                      <p>{chargeDetails?.chargeDate}</p>
                    </Form.Item>
                    <Form.Item label="Posting Date">
                      <p>
                        {chargeDetails?.tenantCharge
                          ? chargeDetails.tenantCharge.postingDate
                          : null}
                      </p>
                    </Form.Item>
                    <Form.Item label="Property">
                      <p className="onclick-text">
                        {chargeDetails?.tenantCharge
                          ? chargeDetails.tenantCharge.property
                          : null}
                      </p>
                    </Form.Item>
                    <Form.Item label="Unit">
                      {" "}
                      <p>
                        {chargeDetails?.tenantCharge
                          ? chargeDetails.tenantCharge.unit
                          : null}
                      </p>
                    </Form.Item>
                    <Form.Item label="GL Account">
                      <p className="onclick-text">{chargeDetails?.glAccount}</p>
                    </Form.Item>
                    <Form.Item label="Description">
                      <p>
                        {chargeDetails?.tenantCharge
                          ? chargeDetails.tenantCharge.description
                          : null}
                      </p>
                    </Form.Item>
                    <Form.Item label="Payment Plan">
                      <p>
                        {chargeDetails?.tenantCharge
                          ? chargeDetails.tenantCharge.paymentPlan
                          : null}
                      </p>
                    </Form.Item>
                  </>
                )}
              </Card>
            </Col>
            {checked ?
            <Col span={24}>
               <FormAction cancel={onCancel} />
            </Col> : null}
            <Col span={24}><ActionsLog /></Col>
            <Col span={24}>
              {/* <Notes /> */}
            </Col>
            <Col span={24}>
              {/* <AttachmentsUpload /> */}
            </Col>
          </Row>
        </Form>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ChargeDetailsRightBar} />
      </div>

      <Modal
        title="Reverse charge for Christopher A. Davis"
        centered
        open={isReverseCharge}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
            Reverse Charge & Unapply Payment
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>

          </div>
        }
      >
        <p>Do you want to reverse this charge? This will also unapply payment from the charge.</p>
        <Form layout="vertical">
          <Form.Item label="Reversal Date" required>
            <DatePicker format="MM-DD-YYYY" style={{width:'100%'}}/>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default ChargeDetails;
